import React from "react";
import ReactDOM from "react-dom/client";
import "normalize.css";
import { ThemeProvider } from "@mui/material/styles";
import "./index.css";
import App from "./App";
import theme from "./theme";
import reportWebVitals from "./reportWebVitals";
import GlobalState from "./Context/GlobalState";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <QueryClientProvider client={queryClient}>
    <GlobalState>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </GlobalState>
  </QueryClientProvider>
);

reportWebVitals();
